import { ReactNode } from 'react';

import { Button, ButtonProps, Stack, Typography } from '@mui/material';

import MiLogo from './../../../assets/mi-logo.svg';

type ButtonPropsType = ButtonProps & { label: ReactNode };

export type AccessDeniedPropType = {
  title?: string | ReactNode;
  description?: string | ReactNode;
  actionButtons?: ActionButtons;
  dataCy?: string;
};
type ActionButtons = {
  primary?: ButtonPropsType;
  secondary?: ButtonPropsType;
};

const getActionButton = (button?: ButtonPropsType) => {
  return button?.label && button.onClick ? button : undefined;
};

const AccessDenied = ({
  title,
  description,
  actionButtons,
  dataCy = 'access-denied',
}: AccessDeniedPropType) => {
  const primaryAction = getActionButton(actionButtons?.primary);
  const secondaryAction = getActionButton(actionButtons?.secondary);

  return (
    <Stack
      data-cy={dataCy}
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <Stack
        spacing={3.75}
        sx={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '600px',
          mb: 12,
        }}
      >
        <img
          src={MiLogo}
          alt="logo"
          width="250px"
          style={{ marginBottom: '34px' }}
        />
        {title && (
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        )}
        {description && (
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
            }}
          >
            {description}
          </Typography>
        )}

        {actionButtons && (
          <Stack spacing={1}>
            {primaryAction && (
              <Button variant="contained" onClick={primaryAction.onClick}>
                {primaryAction.label}
              </Button>
            )}
            {secondaryAction && (
              <Button onClick={secondaryAction.onClick}>
                {secondaryAction.label}
              </Button>
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default AccessDenied;
